import { useState } from 'react';

import { PathwayModal } from '@/components/popups/PathwayModal';

import CreateOrCopyPlanModalStep from './CreateOrCopyPlanModalStep';

interface CreateCustomPlanModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const CreateCustomPlanModal: React.FC<CreateCustomPlanModalProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const [showInvalidNameError, setShowInvalidNameError] = useState(false);

  const handleClose = () => {
    if (showInvalidNameError) {
      setShowInvalidNameError(false);
      return;
    }
    setIsOpen(false);
  };

  const step = showInvalidNameError ? 'invalidName' : 'create';

  return (
    <PathwayModal
      isOpen={isOpen}
      onClose={handleClose}
      stepKey={step}
      className="transition-all 2xl:max-w-[610px]!"
    >
      <CreateOrCopyPlanModalStep
        onCancel={handleClose}
        setShowInvalidNameError={setShowInvalidNameError}
        showInvalidNameError={showInvalidNameError}
      />
    </PathwayModal>
  );
};

export default CreateCustomPlanModal;
